module.exports = {"540324100":"丁青镇","540324101":"尺犊镇","540324200":"觉恩乡","540324201":"沙贡乡","540324202":"当堆乡","540324203":"桑多乡","540324204":"木塔乡","540324205":"布塔乡","540324206":"巴达乡","540324207":"甘岩乡","540324208":"嘎塔乡","540324209":"色扎乡","540324210":"协雄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540324.json
// module id = 2845
// module chunks = 0